import { useMemo } from "react";
import moment from "moment";
import { styled } from "@mui/material";
import AvatarCustom from "components/AvatarCustom/AvatarCustom";
import NormalText from "components/Typography/NormalText";
import SmallText from "components/Typography/SmallText";
import SubTitle from "components/Typography/SubTitle";

const MetaStyled = styled("div")({
  display: "flex",
  gap: "0.5rem",
  alignItems: "center",
  marginBottom: "6px",
});

const ActionComment = ({ comment }) => {
  const dateFormatted = useMemo(
    () => moment(comment.createdAt).format("D MMMM YYYY, hh:mm a"),
    [comment?.createdAt]
  );

  return (
    <>
      <MetaStyled>
        <AvatarCustom name={comment.userName} />
        <SubTitle>{comment.userName}</SubTitle>
        <SmallText>{dateFormatted}</SmallText>
      </MetaStyled>
      <NormalText className="comment-text">{comment.text}</NormalText>
    </>
  );
};

export default ActionComment;
